import { useEffect, useState } from "react";
import api from "@/lib/api";

export const DEFAULT_SETTINGS = {
  phone: "06 66 93 42 67",
  phone_intl: "+33666934267",
  email: "contact@laconciergerierouen.com",
  address: "22 boulevard de la Marne, 76000 Rouen",
  hours: "Tous les jours, 9h – 17h",
};

let cache = null;

// Global editable contact info (NAP), stored under content key "site_settings".
export function useSiteSettings() {
  const [s, setS] = useState(cache || DEFAULT_SETTINGS);
  useEffect(() => {
    if (cache) return;
    api.get("/content/site_settings").then((r) => {
      if (r.data?.value) { cache = { ...DEFAULT_SETTINGS, ...r.data.value }; setS(cache); }
    }).catch(() => {});
  }, []);
  return s;
}
